import React from 'react';
import Button from '../ui/Button';
import Card from '../ui/Card';
import SectionHeader from '../ui/SectionHeader';
import { getRequestStatusTone } from './requestUtils';

function formatEventType(eventType) {
  const normalized = String(eventType || '').toLowerCase();
  if (normalized === 'sick_call') {
    return 'Sick Call';
  }
  if (normalized === 'other_absence') {
    return 'Other Absence';
  }
  if (normalized === 'late_arrival') {
    return 'Late Arrival';
  }
  return normalized.replace(/_/g, ' ') || 'N/A';
}

function RequestDetailCard({
  request,
  title,
  emptyMessage,
  footer = null,
  onOpenPersonWorkspace = null
}) {
  const canOpenWorkspace = Boolean(request && (request.employeeProfileId || request.managerId) && typeof onOpenPersonWorkspace === 'function');

  return (
    <Card as="div" variant="compact" className="role-request-detail-card">
      <SectionHeader
        className="role-section-header"
        title={title}
        actions={(
          <>
            <span>{request ? `#${request.id}` : 'None selected'}</span>
            {canOpenWorkspace ? (
              <Button
                size="sm"
                variant="secondary"
                onClick={() => onOpenPersonWorkspace(request)}
              >
                Open workspace
              </Button>
            ) : null}
          </>
        )}
      />
      {request ? (
        <>
          <div className="role-request-detail-grid">
            <p><strong>Person</strong><span>{request.displayName || request.managerName || 'N/A'}</span></p>
            <p><strong>Status</strong><span className={`role-status-pill ${getRequestStatusTone(request.status)}`}>{request.status}</span></p>
            <p><strong>Type</strong><span>{formatEventType(request.eventType)}</span></p>
            <p><strong>Dates</strong><span>{request.startDate} to {request.endDate}</span></p>
            <p><strong>Time Block</strong><span>{request.timeBlock || 'FULL DAY'}</span></p>
            <p><strong>Location</strong><span>{request.locationCode || 'N/A'}</span></p>
            <p className="role-request-detail-grid__full"><strong>Reason</strong><span>{request.reason || 'No reason provided'}</span></p>
            {String(request.status || '').toLowerCase() === 'denied' ? (
              <p className="role-request-detail-grid__full"><strong>Denial Reason</strong><span>{request.reason || 'Denied without a reason provided.'}</span></p>
            ) : null}
          </div>
          {footer}
        </>
      ) : (
        <p className="role-section-copy">{emptyMessage}</p>
      )}
    </Card>
  );
}

export default RequestDetailCard;
